import { atom } from "jotai";

export const todosAtom = atom([]);
export const activeTodoIdAtom = atom("");
export const availableTasksAtom = atom([]);
export const todoUsersAtom = atom([]);
